import { ENV } from '@/constants/env.constant';
const AccountingMetabaseEmbed = () => {
	return (
		<div className="metabase-embed w-full bg-white rounded-xl overflow-hidden shadow-xs" style={{ height: '100%' }}>
			<iframe
				title="Accounting Dashboard"
				src={ENV.metabasePublicDashboardUrl}
				className="w-full h-full border-none"
				allowFullScreen
				width="800"
				style={{minHeight:'1000px',border:'none'}}
			/>
		</div>
	);
};

export default AccountingMetabaseEmbed;
